// GAVION booking: copy of the public booking pages (spec §2, §4). They render outside the admin i18n, so the strings live
// here: FR by default, EN with ?lang=en. `EN` is typed as `Copy`, so both keep the same keys.
export type PublicLang = "fr" | "en";
export const langOf = (v: string | null | undefined): PublicLang => (v === "en" ? "en" : "fr");

const FR = {
  title: "Réservez une démo de 30 minutes",
  with: "avec %{name}",
  tz: "Heures affichées à l'%{tz}",
  loading: "Chargement des disponibilités…",
  unavailable: "Calendrier indisponible, réessayez plus tard",
  retry: "Réessayer",
  notFound: "Lien de réservation introuvable",
  notFoundDetail: "Ce lien n'est pas actif. Vérifiez l'adresse ou contactez votre représentant.",
  noSlots: "Aucun créneau libre cette semaine.",
  nextWeek: "Semaine suivante",
  prevWeek: "Semaine précédente",
  pick: "Choisissez un moment",
  selected: "Démo de 30 minutes le %{when}",
  change: "Changer de moment",
  name: "Nom",
  company: "Entreprise",
  email: "Courriel",
  phone: "Téléphone",
  website: "Site web (laisser vide)",
  consent: "En réservant, vous acceptez d'être contacté au sujet de cette démo.",
  purpose: "Nous utilisons ces renseignements uniquement pour organiser cette démo et vous la rappeler.",
  submit: "Réserver",
  submitting: "Réservation…",
  required: "Champ obligatoire",
  invalidEmail: "Courriel invalide",
  invalidPhone: "Numéro de téléphone invalide (10 chiffres)",
  taken: "Ce créneau vient d'être pris.",
  alreadyBooked:
    "Vous avez déjà une démo prévue avec %{rep} : utilisez le lien reçu par courriel pour la déplacer.",
  inProgress: "Votre réservation est en cours de traitement. Réessayez dans quelques minutes.",
  rescheduleLimit: "Contactez votre représentant pour changer encore la date.",
  rateLimited: "Trop de demandes. Réessayez plus tard.",
  error: "Une erreur est survenue. Réessayez.",
  doneTitle: "C'est réservé",
  doneWhen: "Le %{when}",
  doneDetail: "Vous recevrez l'invitation Teams par courriel.",
  received: "Demande reçue : vous recevrez l'invitation par courriel sous peu.",
  manageLink: "Choisir un autre moment ou annuler",
  switchLang: "English",
  manageTitle: "Votre démo Gavion",
  loadingBooking: "Chargement de votre démo…",
  reschedule: "Choisir un autre moment",
  cancel: "Annuler la démo",
  confirmCancel: "Confirmer l'annulation",
  keep: "Garder la démo",
  rescheduled: "Démo déplacée au %{when}",
  cancelled: "Démo annulée.",
  expired: "Lien expiré : contactez %{rep}",
  yourRep: "votre représentant",
};
type Copy = typeof FR;
const EN: Copy = {
  title: "Book a 30-minute demo",
  with: "with %{name}",
  tz: "Times shown in %{tz}",
  loading: "Loading availability…",
  unavailable: "Calendar unavailable, please try again later",
  retry: "Try again",
  notFound: "Booking link not found",
  notFoundDetail: "This link is not active. Check the address or contact your representative.",
  noSlots: "No free time this week.",
  nextWeek: "Next week",
  prevWeek: "Previous week",
  pick: "Pick a time",
  selected: "30-minute demo on %{when}",
  change: "Change time",
  name: "Name",
  company: "Company",
  email: "Email",
  phone: "Phone",
  website: "Website (leave empty)",
  consent: "By booking, you agree to be contacted about this demo.",
  purpose: "We use this information only to organise this demo and remind you of it.",
  submit: "Book",
  submitting: "Booking…",
  required: "Required",
  invalidEmail: "Invalid email",
  invalidPhone: "Invalid phone number (10 digits)",
  taken: "This time was just taken.",
  alreadyBooked:
    "You already have a demo scheduled with %{rep}: use the link you received by email to move it.",
  inProgress: "Your booking is being processed. Please try again in a few minutes.",
  rescheduleLimit: "Contact your representative to change the date again.",
  rateLimited: "Too many requests. Please try again later.",
  error: "Something went wrong. Please try again.",
  doneTitle: "You're booked",
  doneWhen: "On %{when}",
  doneDetail: "You will receive the Teams invitation by email.",
  received: "Request received: you will get the invitation by email shortly.",
  manageLink: "Choose another time or cancel",
  switchLang: "Français",
  manageTitle: "Your Gavion demo",
  loadingBooking: "Loading your demo…",
  reschedule: "Choose another time",
  cancel: "Cancel the demo",
  confirmCancel: "Confirm the cancellation",
  keep: "Keep the demo",
  rescheduled: "Demo moved to %{when}",
  cancelled: "Demo cancelled.",
  expired: "Link expired: contact %{rep}",
  yourRep: "your representative",
};
export const BOOKING_COPY: Record<PublicLang, Copy> = { fr: FR, en: EN };
export const fill = (s: string, v: Record<string, string>): string =>
  s.replace(/%\{(\w+)\}/g, (_, k: string) => v[k] ?? "");
